// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"a9702192","350":"607a87bf","511":"16ec3167","552":"ceb55a2c","564":"ababb7aa","882":"77d98e3a"}[chunkId] + ".chunk.js";
};